export default __webpack_public_path__ + "static/media/nigeria.9046dfd5.png";